module.exports = __webpack_public_path__ + "static/media/entity-viewer-terms.942070c5.png";